const EDIT = 'EDIT';
const CANCEL = 'CANCEL';

export { EDIT, CANCEL };
